var bundle;

bundle = {
  init: function() {
    if ($(".template-product").length > 0) {
      bundle.event();
      setTimeout(bundle.updateStock, 1000);
      bundle.reorderSize();
      // $('.additional').slick({
      //   dots: true,
      //   infinite: false
      // });
      // $('[data-value="Sienne"]').click();

    }
  },
  event: function() {
    $(".add-to-cart--bundle").on("click", bundle.addToCart);
    $("li[data-type][data-color] a").on("click", bundle.updatePrice);
    $('body').on("click", ".color li a", bundle.updateStock);
    $(".pillow-selector").on('click', bundle.addPillows);

  },
  addToCart: function() {
    console.log("ADD TO CART EVENT");
    $(".error.general").hide();
    $(".error:not(.general)").hide();
    $(".error:not(.general) span").remove();
    var sizes_selector = $('.variants .size');
    var error = false;

    $('#variantstop.variants .size').each(function() {
      var selected_size = $(this).find("[data-value]");
      // console.log(selected_size.attr("data-value"));
      if (selected_size.length == 0 || selected_size.attr("data-value").length == 0) {
        error = true;
        $(this).find(".error").append("<span>" + $("[data-empty]").attr("data-empty") + "</span>");
        $(this).find(".error").fadeIn();
      }
    });
    
    
    if (!error) {
      variants_title = [];

      $('#variantstop.variants .size').each(function() {
        var variant_name = $(this).find("[data-type]").attr("data-type");
        var variant_value = $(this).find("[data-value]").attr("data-value");
        var variant_color = $(this).find('.variantlist li.active a').attr("data-value");
        var variant_title = variant_name == "Housse de couette" ? variant_color + " / " + variant_name + ": " + variant_value : variant_name + ": " + variant_value;
        variants_title.push(variant_title);
      });
      
      var find_variant = false;
      $(".product-variant").each(function() {
        var value = $(this).attr("value");
        var s = value.split(" / ")[0] + " / " + value.split(" / ")[1];


        if (s == variants_title[0] && value.split(" / ")[2] == variants_title[1] && value.split(" / ")[3] == variants_title[2]) {
          find_variant = true;
          var originalText = $(".add-to-cart--bundle").html();
          $(".add-to-cart--bundle").html('<i></i> ' + $(".add-to-cart--bundle").attr('data-loading'));
          
          var params = {
            quantity: $(".product").find('[name="quantity"]').val()
          };
          
          var variant_color_parsed = $('.color .active').find("a").attr("class");
          var variant_color = $('.color .active').find("a").attr("data-value");

          var products_ids = [];
          var products_titles = [];
          var products_sku = [];

		  var featured_img = "";
          
          var pillows_data = null;
          
          $('.size .selected [data-mix="size"]').each(function() {
            var new_color = "";
            var variant_color = $(this).next().attr("data-value");
            variant_color = variant_color.toLowerCase().replaceAll("-", " ");
            //console.log($(this).attr("data-type"));

            console.log('0000 =', $('.option-bundle[data-option1="' + variant_color + '"][data-title="' + $(this).attr("data-type") + '"][data-option2="' + $(this).attr("data-value") + '"]'))
            var product = $('.option-bundle[data-option1="' + variant_color + '"][data-title="' + $(this).attr("data-type") + '"][data-option2="' + $(this).attr("data-value") + '"]');
            // console.log('.option-bundle[data-option1="' + variant_color + '"][data-title="' + $(this).attr("data-type") + '"][data-option2="' + $(this).attr("data-value") + '"]');
            // console.log(product);
            // console.log(product.html());
            products_ids.push(product.attr("value"));
            products_sku.push(product.attr("data-sku"));             
            if(typeof product.html() !== "undefined"){
              // console.log(product.html().split("-")[0],'value');
              products_titles.push($(this).attr("data-type") + " - " + product.html().split("-")[0].trim());
            }else{
              find_variant = false;
            }
            if ($(this).attr("data-type") == "Housse de couette") {
              featured_img = product.attr('data-featured-img'); 
            }


            // console.log($(this).attr("data-type"));
            // console.log(product);
            // console.log('@@11');
            if ($('.pillow-selector').hasClass('actif') && $(this).attr("data-type") == "2 x Taies d'Oreillers") {
              pillows_data = {
                "id": parseInt(product.attr("value")),
                "quantity": 1
              }
            }

          });

          // console.log('find_variant ====', find_variant)
          if(find_variant){
            params.id = $(this).attr("data-value");
            var i1 = products_titles[0].split(" - ")[0];
            var i2 = products_titles[1].split(" - ")[0];
            var i3 = products_titles[2].split(" - ")[0];
            
            var i1_s = products_titles[0].split(" - ")[1].split(" / ")[1];
            var i2_s = products_titles[1].split(" - ")[1].split(" / ")[1];
            var i3_s = products_titles[2].split(" - ")[1].split(" / ")[1];
  
  
            params.properties = {
              "_bundle-type": "mix-and-match",
              "_product1_sku": products_sku[0],
              "_product2_sku": products_sku[1],
              "_product3_sku": products_sku[2],
              "_product1_id" : products_ids[0],
              "_product2_id":  products_ids[1],
              "_product3_id":  products_ids[2],
              "_bundle": "true",
              "_colorimg": featured_img
            }
  
            params.properties[i1] = products_titles[0].split(" - ")[1].replace(" / Single", "").split("/")[0];
            params.properties[i2] = products_titles[1].split(" - ")[1].replace(" / Single", "").split("/")[0];
            params.properties[i3] = products_titles[2].split(" - ")[1].replace(" / Single", "").split("/")[0];
  
            
            console.dir(params);
            
            var params2 = null;
            if (pillows_data != null) {
              var params2 = {
                "items": [
                  params,
                  pillows_data
                ]
              }
            }
            
            $.ajax({
              type: 'post',
              url: '/cart/add.js',
              data: params2 != null ? params2 : params,
              dataType: 'json',
              complete: function(res) {
                var element, item;
                var cur = $('body').attr('data-currency');
                console.log('------------=========');
                if (typeof pintrk != 'undefined') {
                  pintrk('track', 'addtocart',
                   {value: parseInt(params.price),
                    order_quantity: params.quantity,
                    currency: cur
                   });
                }
                
                
                if (res.status === 200) {
                  $(".product").find('.add-to-cart--bundle').html(originalText);
                  item = res.responseJSON;
                 	
                  console.log("ITEM1111->>");
                  console.dir(item);
  
                  var new_item = null;
                  var pillows_item = null;
                  if ('items' in item && item.items.length > 1) {
                    for (var i = 0;i < item.items.length;i++) {
                      if (item.items[i].properties != null) {
                        new_item = item.items[i];
                        break
                      }
                    }
                  }
                   if ('items' in item && item.items.length > 1) {
                    for (var i = 0;i < item.items.length;i++) {
                      if (item.items[i].properties == null || !(i1 in item.items[i].properties)) {
                        pillows_item = item.items[i];
                        break
                      }
                    }
                  }
                  
                  if (new_item != null) {
                    item = new_item;
                  }
                  
                  console.log(item)
                  
                  var titles = [];
  
                  console.log(item.properties);
                  titles.push(i1 + ': ' + item.properties[i1] + ' - ' + i1_s);
                  titles.push(i2 + ': ' + item.properties[i2] + ' - ' + i2_s);
                  titles.push(i3 + ': ' + item.properties[i3] + ' - ' + i3_s);
  
                  var old_basket = basketPopupItem;
                  element = basketPopupItem.replace('properties"', 'properties" style="display: none"').replace('[price]', Shopify.formatMoney(item.line_price, "€{{amount_with_comma_separator}}")).replace('[image]', item.properties._colorimg).replace('[url]', item.url).replace('[title]', item.product_title).replace('[variant]', titles.join("<br>")).replace('[quantity]', item.quantity).replace('[mquantity]', item.quantity).replace('[mprice]', Shopify.formatMoney(item.line_price, "€{{amount_with_comma_separator}}"));
  	
                  var pillow_element = null;
                  if (pillows_item != null) {
                    item = pillows_item;
                    pillow_element = old_basket.replace('properties"', 'properties" style="display: none"').replace('[price]', Shopify.formatMoney(item.line_price, "€{{amount_with_comma_separator}}")).replace('[image]', item.image).replace('[url]', item.url).replace('[title]', item.product_title).replace('[variant]', titles[2]).replace('[quantity]', item.quantity).replace('[mquantity]', item.quantity).replace('[mprice]', Shopify.formatMoney(item.line_price, "€{{amount_with_comma_separator}}"));
                  }
                  
                  console.log(pillow_element);
                  
                  //$(".basket .details .variant").html($(".basket .details .variant").html().replace(" / ", "<br>"));
                  $('.basket-popup .basket').html(pillow_element != null ? element.replace("item grid", "item grid has_pillows") + pillow_element : element);
                  $('.basket-popup .complete').show();
  
                  $('body').addClass('overlay');
                  $('.basket-popup').addClass('active');
  
                  
  
                  $.ajax({
                    type: 'get',
                    url: '/cart.js',
                    dataType: 'json',
                    complete: function(res) {
                      var cart, itemsHTML;
                      if (res.status === 200) {
                        cart = res.responseJSON;
                        $.get( "/cart?view=minicart", function( data ) {
                          $('.cartitemmodel').html(data);
                          // triggerFreeProduct();
                        });
                        $('header ul li.cart > a span').attr('data-count',cart.items.length).parent().addClass('fill');
                        if(cart.items.length <= 1){
                          $('.dropdown.minicartmain').addClass('BasketHas');
                        }else{
                          $('.dropdown.minicartmain').removeClass('BasketHas');
                        }
                      }
                    }
                  });
                  
                 
                } else {
                  product.find('.add-to-cart--bundle').html(originalText);
                  if($(window).width() < 768 ){
                    $('html, body').animate({
                      scrollTop: $("#variantstop").offset().top - 100
                    }, 2000);
                  }
                  return product.find('.error.general').text(res.responseJSON.description).show();
  
                }
              }
            });
          }else{                                   
              $(".form_add_btn .add-to-cart--bundle").html(originalText);            
          }
        }
      });
    } else {
      if ($(this).hasClass("add-to-cart--scroll")) {
          $("html, body").animate({ scrollTop: $("#variantstop.variants")[0].offsetTop - 80 }, 600);
          $('section.product .formButtonOuter .add-to-cart--bundle').removeClass('add-to-cart--scroll');
      }
    }    
    if (find_variant == false) {
     $(".error.general").html("Cette combinaison de tailles est disponible sur demande. Écrivez-nous à <a href='mailto:contact@greige.fr'>contact@greige.fr</a> en indiquant le modèle et les tailles souhaitées, et notre équipe vous répondra dans les plus brefs délais.").fadeIn(); 
    }
  },
  updatePrice: function() {
    var variants_title = [];

    $('.variants .size').each(function() {
      var variant_name = $(this).find("[data-type]").attr("data-type");
      var variant_value = $(this).find("[data-value]").attr("data-value");
      var variant_title = variant_name + ": " + variant_value;
      variants_title.push(variant_title);
    });


    $(".product-variant").each(function() {
      var value = $(this).attr("value");
      
      //console.log(variants_title);

      if (value.indexOf(variants_title[0]) > -1 && value.indexOf(variants_title[1]) > -1 && value.indexOf(variants_title[2]) > -1) {
        $(".details .grid.hspace-between-xs .price").html($(this).attr("data-price")).attr('data-pricepint',$(this).attr("data-pricepint"));
         var armaPrice = parseInt($(this).attr("data-pricepint")) / 3;
        $('.alma-wrp').find('p').html(`ou 3 fois ${Math.round(armaPrice)}€`)
        $(".product__pricing .price").html($(this).attr("data-price")).attr('data-pricepint',$(this).attr("data-pricepint"));
        if($('.basket_bar_price').length > 0 ){
          $('.basket_bar_price').html($(this).attr("data-price")).attr('data-pricepint',$(this).attr("data-pricepint"));
        }
      }
    });
  },
  updateStock: function() {
   
    $('[data-color][data-idd]').removeClass("unavailable-product");
    
    //console.log(color);
    
    $('.variants .size').each(function() {
      console.log('000 =', $(this).find('.active'))
      var color = $(this).find('.active a').attr("data-value").toLowerCase();
      var variant_name = $(this).find("[data-type]").attr("data-type");
      var variant_value = $(this).find("[data-value]").attr("data-value");
      var type = $(this).attr("sizet");
      
      $('.option-bundle[data-title="' + variant_name + '"][data-option1="' + color.replace("-", " ") + '"][data-title="' + type + '"]').each(function() {
        if (parseInt($(this).attr("data-stock")) == 0) {
            // console.log(color + 'li[data-size="' + $(this).attr("data-option2") + '"][data-type="' + type+ '"]');
          $('li[data-size="' + $(this).attr("data-option2") + '"][data-type="' + type+ '"].actif').closest(".mix-and-match__sizes").find("span[data-size]").removeAttr("data-value").html("Sélectionner");
          $('li[data-size="' + $(this).attr("data-option2") + '"][data-type="' + type+ '"].actif').closest(".size--mix-and-match").find('span[data-mix="size"]').removeAttr("data-value").html("Sélectionner");

          $('li[data-size="' + $(this).attr("data-option2") + '"][data-type="' + type+ '"]').addClass("unavailable-product").removeClass('actif');
        }
      });
    });
  },
  reorderSize: function() {
    var div = $("#variantstop");
    //div.children().each(function(i,li){div.prepend(li)})
    
    
    $("#variantstop .drop ul").each(function() {
      var $wrapper = $(this);
      $wrapper.find('[data-size]').sort(function(a, b) {
        return +a.dataset.sortvalue - +b.dataset.sortvalue;
      })
      .appendTo($wrapper);
    });

  },
  addPillows: function() {
   $('.pillow-selector').toggleClass('actif'); 
    if ($('.pillow-selector').hasClass('actif')) {
		
    }
  }
};


$(document).ready(function() {
  bundle.init();
});
